import { z } from 'zod'

export const USERNAME_MIN_LENGTH = 3
export const USERNAME_MAX_LENGTH = 20

export const UsernameSchema = z
	.string({ required_error: 'Benutzername ist ein Pflichtfeld' })
	.min(USERNAME_MIN_LENGTH, { message: 'Benutzername ist zu kurz' })
	.max(USERNAME_MAX_LENGTH, { message: 'Username ist zu lang' })
	.regex(/^[a-zA-Z0-9_]+$/, {
		message:
			'Der Benutzername darf nur Buchstaben, Zahlen und Unterstriche enthalten.',
	})
	// users can type the username in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordSchema = z
	.string({ required_error: 'Passwort ist ein Pflichtfeld' })
	.min(2, { message: 'Passwort ist zu kurz' })
	// NOTE: bcrypt has a limit of 72 bytes (which should be plenty long)
	// https://github.com/epicweb-dev/epic-stack/issues/918
	.refine((val) => new TextEncoder().encode(val).length <= 72, {
		message: 'Passwort ist zu lang',
	})

export const NameSchema = z
	.string({ required_error: 'Name ist ein Pflichtfeld' })
	.min(2, { message: 'Name ist zu kurz' })
	.max(40, { message: 'Name ist zu lang' })

export const EmailSchema = z
	.string({ required_error: 'E-Mail ist ein Pflichtfeld' })
	.email({ message: 'E-Mail ist ungültig' })
	.min(3, { message: 'E-Mail ist zu kurz' })
	.max(100, { message: 'E-Mail ist zu lang' })
	// users can type the email in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordAndConfirmPasswordSchema = z
	.object({ password: PasswordSchema, confirmPassword: PasswordSchema })
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ['confirmPassword'],
				code: 'custom',
				message: 'Die Passwörter müssen übereinstimmen.',
			})
		}
	})
